
export interface UserSession  {
    sessionId:string
    engine:{
        engineId:string
        engineTitle:string
        engineCoverURL:string
        type:string 
        engineBackgroundImageURL:string
    }
}

export enum EngineStatus {
    PUBLISHED = 'published',
    DRAFT = 'draft',
}